<div class="container-fluid animated fadeIn">
	<div class="row flex-column align-items-center my-5">
		<!-- STEPS TITLE -->
		<div class="col-12 mb-4">
			<div class="wiz-title text-center">
				{{ 'supplier-upload.pageTitle' | translate }}
			</div>
		</div>
		<!-- CARD -->
		<div class="col-12 col-xl-12">
			<eif-custom-stepper
				[steps]="steps"
				[currentStep]="currentStep">
			</eif-custom-stepper>

			<div class="simple-card top-line p-4">
				<div class="upload-bar-title fw-6">{{ 'supplier-upload-step3.UploadDocStateLineTitle' | translate }}</div>
				<div class="d-flex col-12 upload-status-content">
					@if (loadedRecordsCounts | async) {
						<eif-custom-upload-state-bar
							[countValidRecords]="totalValidRecords"
							[countInvalidRecords]="totalInvalidRecords">
						</eif-custom-upload-state-bar>
					}
				</div>
				@if (showValidationResults) {
					<eif-suppliers-upload-validation-result
						[validationResultRecords]="contentValidationData"
						[showColumnActiveAutomaticFundingRequest]="showColumnActiveAutomaticFundingRequest"
						class="validation-result-table"></eif-suppliers-upload-validation-result>
				}
			</div>

			<div class="d-flex align-items-center justify-content-between">
				<div class="d-flex flex-grow-1">
					<a
						role="button"
						class="is-color-primary"
						(click)="openInstructionsModal()">
						<i class="fa-solid fa-info-circle me-2"></i>
						<span>{{ 'supplier-upload.howToUpload' | translate }}</span>
					</a>
				</div>
				<!-- BUTTONS AREA -->
				<div class="d-flex align-items-center justify-content-xs-center justify-content-end p-4">
					<div>
						<eif-custom-button
							[text]="'button.back' | translate"
							[color]="'neutral'"
							[class]="'mb-0'"
							(action)="backToUploadStep()">
						</eif-custom-button>
					</div>
					<div>
						<eif-custom-button
							[hidden]="contentValidationData.length === 0"
							[text]="'supplier-upload-step3.goToNextStep' | translate"
							[postIcon]="'fa-light fa-chevron-right'"
							[class]="'mb-0 ms-2'"
							(action)="submitRecords()">
						</eif-custom-button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
